<template>
  <v-form ref="form">
    <v-autocomplete
      id="temas-select"
      v-model="value.territorioCategoria"
      :items="values"
      label="Categorias"
      placeholder="Selecione..."
      v-on:change="
        (e) => {
          $emit('onChange', value);
        }
      "
      :disabled="disabled"
      :clearable="clearable"
      :multiple="multiple"
      item-value="territorioCategoriaId"
      item-text="nomeCategoria"
      :rules="rules"
      :return-object="object"
      :outlined="outlined"
      hide-details="auto"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-bind="item" small v-if="index < maxDisplay">
          <span>{{ item.nomeCategoria }}</span>
        </v-chip>
      </template>
      <template slot="no-data"> Nenhuma Categoria retornado </template>
    </v-autocomplete>
  </v-form>
</template>

<script>
import { territoriosCategoriaAPI } from "@/modules/gestao-territorios/API/territoriosCategoriaAPI";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ComboboxMunicipioTerritorio",
  computed: {
    ...mapGetters(["isSala", "isParceiro"]),
  },
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    clearable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array | Object },
    filterByTerritorios: { type: Number },
    object: false,
    outlined: false,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    loadCities() {
      this.setLoading(true);
      territoriosCategoriaAPI
        .list()
        .then((resp) => {
          this.values = resp.data;
          this.allValues = resp.data;
          this.setLoading(false);
        })
        .catch((e) => {
          console.log("error on comboboxTerritorioCategoria: ", e);
          this.$notification.error("Error ao buscar territorios categorias");
          this.setLoading(false);
        });
    },
  },
  mounted() {
    this.loadCities();
  },

  data() {
    return {
      values: [],
      allValues: [],
      maxDisplay: 1,
    };
  },
};
</script>
